import * as React from 'react';
import { FC } from 'react';

interface ModelSchemaArticle {
  type: string;
  headline: string;
  image?: string;
  datePublished?: string;
  dateModified?: string;
  mainEntityOfPage?: string;
  description?: string;
}

const SchemaArticle: FC<ModelSchemaArticle> = (props) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': props.type,
    headline: props.headline,
    author: [
      {
        '@type': 'Organization',
        name: 'Destinasjon Trysil',
        url: 'https://www.trysil.com',
      },
    ],
    publisher: {
      '@type': 'Organization',
      name: 'Destinasjon Trysil',
    },
  };

  if (props.type) {
    Object.assign(structuredData, { type: props.type });
  }

  if (props.headline) {
    Object.assign(structuredData, { headline: props.headline });
  }

  if (props.datePublished) {
    Object.assign(structuredData, { datePublished: props.datePublished });
  }

  if (props.dateModified) {
    Object.assign(structuredData, { dateModified: props.dateModified });
  }

  if (props.image) {
    Object.assign(structuredData, { image: props.image });
  }

  if (props.mainEntityOfPage) {
    Object.assign(structuredData, { mainEntityOfPage: props.mainEntityOfPage });
  }

  if (props.description) {
    Object.assign(structuredData, { description: props.description });
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
    />
  );
};
export default SchemaArticle;
